export default __webpack_public_path__ + "static/media/21648.7107cf62.jpg";